module.exports = __webpack_public_path__ + "img/10.2.TN.8c4198d5.png";